import React, { useEffect, useState } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import { post } from '../../../../services/back.service';
import LoadingSpinner from '../../../shared/loaderSpinner';
import useAutosave from '../../../../hooks/useAutosave';

function FormCompFluidsMoto({ id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [msgButton, setMsgButton] = useState('Guardar Informacion');
  const [infoCompFluids, setInfoCompFluids] = useState({
    suspension: 'NO APLICA',
    fuel: 'NO APLICA',
  });
  const [states, setStates] = useState([]);

  const autosave = useAutosave(async () => {
    await post('/peritaje/modifyinspection/components/' + id, { type: 'FC', data: infoCompFluids });
  });

  const handleForm = ({ target }) => {
    const tmpCompFluids = { ...infoCompFluids, [target.name]: target.value };
    setInfoCompFluids(tmpCompFluids);
    autosave.schedule();
    //generalUpdate('infoCompFluids', tmpCompFluids)
  };

  const getInfoState = async () => {
    setStates([
      {
        id: 'NO',
        name: 'NO',
      },
      {
        id: 'SI',
        name: 'SI',
      },
      {
        id: 'NO APLICA',
        name: 'NO APLICA',
      },
    ]);
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const body = { type: 'FC', data: infoCompFluids };
    const respo = await post(
      '/peritaje/modifyinspection/components/' + id,
      body,
    );
    if (respo.success) {
      setMsgButton('Actualizar');
    }
  };
  useEffect(() => {
    const initForm = async () => {
      setIsLoading(true);
      const body = { type: 'FC' };
      let tmpFluids = {};
      const respo = await post(
        '/peritaje/infodetailinspection/components/' + id,
        body,
      );
      if (respo.success) {
        const { detail } = respo.data;
        if (detail.length > 0) {
          for (let i = 0; i < detail.length; i++) {
            const element = detail[i];
            tmpFluids[element.name] = element.des_state;
          }
        } else {
          tmpFluids = {
            suspension: 'NO APLICA',
            fuel: 'NO APLICA',
          }
        }
        setInfoCompFluids(tmpFluids);
      }
      setIsLoading(false);
    };
    getInfoState();
    initForm();
  }, [id]);

  return (isLoading) ? <LoadingSpinner /> : (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">FUGA DE FLUIDOS</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="fluidos">SUSPENCION</Form.Label>
          <Form.Select
            name="suspension"
            value={infoCompFluids.suspension}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="fluidos">COMBUSTIBLE</Form.Label>
          <Form.Select
            name="fuel"
            value={infoCompFluids.fuel}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormCompFluidsMoto;
